import { api } from "@/axios";
import responseHandler from "@/responseHandler.js";

const state = {
  repeats: [],
};

const getters = {
  getRepeats: (state) => state.repeats,
  getRepeatById: (state) => (id) => state.repeats.find((x) => x.id == id),
};

const actions = {
  async exportRepeats() {
    try {
      const resp = await api.get("/repeats_export");
      if (resp.status == 200) {
        return resp.status;
      }
    } catch (error) {
      console.log("error", error);
      return error.status;
    }
  },
  async fetchRepeats({ commit }) {
    try {
      const resp = await api.get("/repeats");
      if (resp.status == 200) {
        const repeats = resp.data.data.repeats;
        console.log("resp\n", resp);
        console.log("repeats", repeats);
        commit("setRepeats", repeats);
      }
    } catch (error) {
      console.log("error", error);
      return false;
    }
  },
  async updateRepeat({ commit }, repeat) {
    console.log("repeat:", repeat);
    repeat.isAccepted = repeat.isAccepted ? 1 : 0;
    try {
      const id = repeat.id;
      repeat._method = "patch";

      const resp = await api.post(`/repeats/${id}`, repeat);
      if (resp.status == 200) {
        const repeat = resp.data.data;
        console.log("repeat back", repeat);
        commit("updateRepeat", repeat);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      console.log("error", error);
      return responseHandler.respH1(error.response);
    }
  },
  async addRepeat({ commit }, repeat) {
    try {
      const resp = await api.post(`/repeats`, repeat);

      if (resp.status == 201) {
        const repeat = resp.data.data;

        commit("addRepeat", repeat);
      }
      console.log("resp:", resp);
      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },
  async deleteRepeat({ commit }, id) {
    try {
      const resp = await api.delete(`/repeats/${id}`);

      if (resp.status == 204) {
        commit("deleteRepeat", id);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },
  // async acceptRepeat({ commit }, id) {
  //   try {
  //     const resp = await api.delete(`/repeats_accept/${id}`);

  //     if (resp.status == 200) {
  //       commit("acceptRepeat", id);
  //     }
  //     return responseHandler.respH1(resp);
  //   } catch (error) {
  //     return responseHandler.respH1(error.response);
  //   }
  // },
};

const mutations = {
  setRepeats(state, repeat) {
    state.repeats = repeat;
  },
  updateRepeat(state, repeat) {
    const id = repeat.id;
    const index = state.repeats.findIndex((repeat) => repeat.id == id);
    if (index !== -1) {
      state.repeats[index] = repeat;
    }
  },
  addRepeat(state, repeat) {
    state.repeats.unshift(repeat);
  },

  deleteRepeat(state, id) {
    const index = state.repeats.findIndex((p) => p.id == id);
    if (index !== -1) {
      state.repeats.splice(index, 1);
    }
  },
  // acceptRepeat(state, id) {
  //   const index = state.repeats.findIndex((p) => p.id == id);
  //   if (index !== -1) {
  //     state.repeats.splice(index, 1);
  //   }
  // },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
